import React from 'react';
import GeocodingApiService from '../../services/geocoding-api-service';
import SearchContext from '../../contexts/SearchContext';

import './CurrLocBtn.css';

export default class CurrLocBtn extends React.Component {
  static contextType = SearchContext
  state = { loading: false, enableOutline: false }

  getLocation = () => {
    this.setState({ loading: true })

    const options = {
      timeout: 5000,
      enableHighAccuracy: false,
      maximumAge: 0
    };

    const success = async pos => {
      try {
        const { latitude, longitude } = pos.coords;
        const res = await GeocodingApiService.getZip(latitude, longitude);
        const zipCode = res.results[0].address_components[0].long_name;
        this.context.setZipCode(zipCode);
        this.setState({ loading: false });
      } catch (err) {
        console.log(err);
      }
    };

    const error = err => {
      // console.log('ERROR')
      // console.log(err.message)
      this.setState({ loading: false })
    }

    navigator.geolocation.getCurrentPosition(success, error, options)
  }

  componentDidMount() {
    window.addEventListener('keydown', this._handleKeydown)
  }

  _handleKeydown = e => {
    // Detect a keyboard user from a tab key press
    const isTabEvent = e.keyCode === 9
    if (isTabEvent) {
      this.setState({ enableOutline: true })
    }
  }

  render() {
    return (
      // <button onClick={this.getLocation} type='button'>get pos</button>

      <button
        onClick={this.getLocation}
        className={`CurrLocBtn ${
          this.state.enableOutline ? '' : 'no-focus-CurrLocBtn'
        }`}
        type="button"
      >
        <svg
          className="loc"
          // xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 489.032 489.032"
          // viewBox="50 50 550 550"
        >
          <path
            // className="loc-mid"
            className={this.state.loading ? 'loc-mid-loading' : 'loc-mid'}
            fill="#3c92ca"
            width="100%"
            height="100%"
            d="M180.766 184.526c0-1.7 1.5-2.6 3.3-1.8 4.3 1.9 8.5 3.8 12.7 5.8l132 60c1.1.5 2.2 1 2.2 2.5s-1.1 1.9-2.3 2.4c-18.4 7.4-36.7 14.7-55.1 22.1-7.3 18.3-14.7 36.6-22 55-.5 1.1-.9 2.3-2.4 2.3-1.6.1-2.1-1-2.7-2.2-21.7-48-43.4-96-65-143.9-.3-.8-.8-1.4-.7-2.2z"
          />
          <path
            // className="loc-dots"
            className={this.state.loading ? 'loc-dots-loading' : 'loc-dots'}
            width="100%"
            height="100%"
            d="M231.166 95.826c5-.4 8.7-4.9 8.2-9.8-.5-5-4.9-8.7-9.8-8.2-5 .4-8.7 4.9-8.2 9.8.4 4.7 4.4 8.3 9 8.3.2 0 .5-.1.8-.1zm11.3 316.2c5 0 9-4 9.1-9s-3.9-9.1-8.9-9.2-9.1 3.9-9.2 8.9c-.1 5 3.9 9.1 8.9 9.2 0 .1 0 .1.1.1zm-145.9-146.7c-.7-5-5.3-8.4-10.3-7.7-5 .7-8.4 5.3-7.7 10.2.6 4.5 4.5 7.8 9 7.8.4 0 .8 0 1.3-.1 5-.6 8.4-5.2 7.7-10.2zm102.3-163.3c.9 0 1.8-.1 2.6-.4 4.8-1.5 7.5-6.5 6.1-11.3-1.5-4.8-6.5-7.5-11.3-6.1s-7.5 6.5-6.1 11.3c1.3 3.9 4.9 6.5 8.7 6.5zm-121.5 132c-.3 5 3.5 9.3 8.5 9.6h.6c4.8 0 8.7-3.7 9-8.5.3-5-3.5-9.3-8.5-9.6s-9.3 3.5-9.6 8.5zm185.1-137.7c4.5 0 8.5-3.4 9-8 .6-5-3-9.5-8-10-5-.6-9.5 3-10 8-.6 5 3 9.5 8 10h1zm31.2 6.8c3.8 0 7.4-2.4 8.6-6.2 1.6-4.8-1-9.9-5.8-11.4-4.8-1.6-9.9 1-11.4 5.8-1.6 4.8 1 9.9 5.8 11.4.9.3 1.9.4 2.8.4zm-171.5 242.5c-3.7 3.4-3.9 9.1-.5 12.8 1.8 1.9 4.2 2.9 6.6 2.9 2.2 0 4.4-.8 6.1-2.4 3.7-3.4 3.9-9.1.5-12.8-3.3-3.7-9.1-3.9-12.7-.5zm14.8-229.4c-3.8 3.2-4.4 8.9-1.1 12.8 1.8 2.1 4.4 3.2 6.9 3.2 2.1 0 4.1-.7 5.8-2.1 3.8-3.2 4.4-8.9 1.1-12.8-3.1-3.8-8.9-4.3-12.7-1.1zm181.5-1.3c1.4.8 3 1.2 4.5 1.2 3.1 0 6.2-1.7 7.9-4.6 2.5-4.4 1-9.9-3.4-12.4s-9.9-1-12.4 3.4-.9 9.9 3.4 12.4zm-223.1 191.8c1 0 2-.2 3-.5 4.7-1.7 7.2-6.9 5.5-11.6s-6.9-7.2-11.6-5.5-7.2 6.9-5.5 11.6c1.3 3.7 4.8 6 8.6 6zm69.7-209.5c-4.4 2.4-6.1 7.9-3.7 12.3 1.7 3 4.8 4.8 8 4.8 1.4 0 2.9-.3 4.3-1.1 4.4-2.4 6.1-7.9 3.7-12.3s-7.9-6.1-12.3-3.7zm6.8 288.4c-2 4.6 0 9.9 4.6 12 1.2.5 2.4.8 3.7.8 3.5 0 6.8-2 8.3-5.4 2-4.6 0-9.9-4.6-11.9-4.6-2.2-10-.1-12 4.5zm-14.2-19.6c-4.1-2.9-9.7-2-12.6 2.1-2.9 4.1-2 9.7 2.1 12.6 1.6 1.1 3.4 1.7 5.3 1.7 2.8 0 5.6-1.3 7.4-3.8 2.8-4.1 1.8-9.7-2.2-12.6zm52.9 42.3c4.2 0 7.9-2.9 8.8-7.1 1.1-4.9-2-9.7-6.9-10.8-4.9-1.1-9.7 2-10.8 6.9s2 9.7 6.9 10.8c.7.1 1.4.2 2 .2zm-84.5-269.3c-3.9-3.1-9.6-2.5-12.7 1.5-3.1 3.9-2.5 9.6 1.5 12.7 1.7 1.3 3.6 2 5.6 2 2.7 0 5.3-1.2 7.1-3.4 3.1-4 2.4-9.7-1.5-12.8zm225.4 209.7c-3.5 3.6-3.4 9.3.2 12.8 1.8 1.7 4 2.6 6.3 2.6 2.4 0 4.7-.9 6.5-2.7 3.5-3.6 3.4-9.3-.2-12.8-3.6-3.6-9.3-3.5-12.8.1zm13.9-206.8c-4 3-4.8 8.7-1.8 12.7 1.8 2.4 4.5 3.6 7.2 3.6 1.9 0 3.8-.6 5.5-1.8 4-3 4.8-8.7 1.8-12.7s-8.7-4.8-12.7-1.8zm18.2 26.4c-4.5 2.1-6.4 7.6-4.3 12.1 1.6 3.3 4.8 5.2 8.2 5.2 1.3 0 2.6-.3 3.9-.9 4.5-2.2 6.4-7.6 4.3-12.1-2.2-4.5-7.6-6.4-12.1-4.3zm-276.3-3.3c-4.5-2.3-9.9-.5-12.2 4-2.3 4.5-.5 9.9 4 12.2 1.3.7 2.7 1 4.1 1 3.3 0 6.5-1.8 8.1-5 2.3-4.5.5-10-4-12.2zm235-45.3c-3.3 3.8-2.9 9.5.8 12.8 1.7 1.5 3.9 2.3 6 2.3 2.5 0 5-1 6.8-3.1 3.3-3.8 2.9-9.5-.8-12.8-3.8-3.4-9.5-3-12.8.8zm-259.3 80.9c-1.3 4.8 1.5 9.8 6.4 11.1.8.2 1.6.3 2.4.3 4 0 7.6-2.7 8.7-6.7 1.3-4.8-1.5-9.8-6.4-11.1-4.8-1.3-9.8 1.5-11.1 6.4zm245.4 167.5c-4.1 2.8-5.2 8.4-2.4 12.6 1.8 2.6 4.6 4 7.5 4 1.8 0 3.5-.5 5.1-1.6 4.1-2.8 5.2-8.4 2.4-12.6s-8.5-5.2-12.6-2.4zm63.9-57.8c3.6 0 7.1-2.2 8.5-5.8 1.8-4.7-.5-9.9-5.2-11.7-4.7-1.8-9.9.5-11.7 5.2-1.8 4.7.5 9.9 5.2 11.7 1 .4 2.1.6 3.2.6zm17.4-38.4c.8-4.9-2.5-9.6-7.5-10.4-4.9-.8-9.6 2.5-10.4 7.5s2.5 9.6 7.5 10.4c.5.1 1 .1 1.5.1 4.3-.1 8.1-3.2 8.9-7.6zm-300.6 63.8c1.6 0 3.2-.4 4.7-1.3 4.3-2.6 5.7-8.2 3.1-12.4-2.6-4.3-8.2-5.7-12.4-3.1-4.3 2.6-5.7 8.2-3.1 12.4 1.6 2.8 4.6 4.4 7.7 4.4zm273.7-13.5c-4.2-2.7-9.8-1.4-12.5 2.8-2.7 4.2-1.5 9.8 2.8 12.5 1.5 1 3.2 1.4 4.9 1.4 3 0 5.9-1.5 7.6-4.2 2.6-4.2 1.4-9.8-2.8-12.5zm-110.1 69c-4.9.9-8.1 5.7-7.2 10.6.8 4.3 4.6 7.4 8.9 7.4.6 0 1.1-.1 1.7-.2 4.9-.9 8.1-5.7 7.2-10.6-1-5-5.7-8.2-10.6-7.2zm29.1-8.8c-.1 0-.1 0-.2.1-4.6 1.9-6.8 7.2-4.9 11.8 1.4 3.5 4.8 5.6 8.4 5.6 1.1 0 2.3-.2 3.4-.7.1 0 .1-.1.2-.1 4.6-1.9 6.8-7.2 4.9-11.8s-7.2-6.8-11.8-4.9zm94.3-184.5c-4.9 1.2-7.8 6.1-6.6 11 1 4.1 4.7 6.9 8.8 6.9.7 0 1.5-.1 2.2-.3 4.9-1.2 7.8-6.1 6.6-11s-6.2-7.8-11-6.6zm6.3 31.4c-5 .2-8.9 4.4-8.7 9.4.2 4.9 4.2 8.7 9 8.7h.4c5-.2 8.9-4.4 8.7-9.4s-4.4-8.8-9.4-8.7z"
          />
          <path
            className={this.state.loading ? 'loc-arrows-loading' : 'loc-arrows'}
            d="M241.666.226c-65.3.8-126.4 26.9-172 73.6-32.7 33.4-55 75.2-64.5 120.7-9.2 44.3-6.1 90.3 9.2 132.8 1.3 3.7 4.8 6 8.5 6 1 0 2-.2 3.1-.5 4.7-1.7 7.2-6.9 5.5-11.6-29.5-82.3-9.9-172.3 51.1-234.8 42.2-43.2 98.8-67.4 159.2-68.1 60.4-.6 117.5 22.2 160.8 64.4l1.4 1.3-27.4.3c-5 .1-9 4.2-9 9.2.1 5 4.1 9 9.1 9h.1l49.2-.6c5-.1 9-4.2 9-9.2l-.5-49.2c-.1-5-4.1-8.9-9.2-9-5 .1-9 4.2-9 9.2l.3 27.4-1.4-1.3c-46.6-45.7-108.2-70.4-173.5-69.6zm-155.4 406.2l-1.4-1.3 27.4-.3c5-.1 9-4.2 9-9.2s-4.2-8.9-9.2-9l-49.2.6c-5 .1-9 4.2-9 9.2l.6 49.2c.1 5 4.1 9 9.1 9h.1c5-.1 9-4.2 9-9.2l-.3-27.4 1.4 1.3c47.5 46.4 109.1 69.5 170.8 69.5 63.5 0 127-24.6 174.8-73.5 32.7-33.4 55-75.2 64.5-120.7 9.2-44.3 6.1-90.3-9.2-132.8-1.7-4.7-6.9-7.2-11.6-5.5s-7.2 6.9-5.5 11.6c29.5 82.3 9.9 172.3-51.1 234.8-87.4 89.2-230.9 90.9-320.2 3.7z"
          />
          <path
            // className="loc-mid-border"
            className={this.state.loading ? 'loc-mid-loading' : 'loc-mid'}
            d="M174.866 176.626c-2 2.1-3.2 4.9-3.2 7.9 0 2.8 1 4.8 1.5 5.9l65 143.9c2.8 6.2 7.4 7.6 10.8 7.6h.6c3.3-.2 7.8-1.7 10.3-8l7.3-18.2c4.4-11.1 8.9-22.1 13.3-33.2 12.3-4.9 24.5-9.8 36.8-14.7l14.8-5.9c6.9-2.8 8-7.9 8-10.7 0-3.4-1.2-8-7.5-10.8-34-15.4-67.9-30.9-101.9-46.3l-33-15-9.9-4.5c-4.6-2.2-9.7-1.3-12.9 2zm48.2 33.8c29.4 13.4 58.8 26.8 88.3 40.2l-.9.3c-13.4 5.4-26.9 10.8-40.3 16.1-2.3.9-4.2 2.8-5.1 5.1-4.9 12.3-9.8 24.5-14.7 36.8l-1.8 4.4-51.9-114.8 26.4 11.9z"
          />
        </svg>
      </button>
    )
  }
}
